var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompliancePdfFileLargeExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 147,
  height: 154,
  viewBox: "0 0 147 154",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#7yuizacxoa)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 5h96.213L142 41.793V145a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.213 5 142 41.793h-32.787a4 4 0 0 1-4-4V5z",
  fill: "#ABABAB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.749 82.51c-1.49-1.276-2.98-2.872-4.681-4.574-1.17-1.276-2.447-3.085-3.51-5 2.02-6.915 2.978-13.51.85-16.702-.957-1.49-2.447-2.234-4.362-2.234-2.127 0-3.723.957-4.468 2.766-1.702 3.83.852 10.851 3.937 16.596-.852 2.766-1.915 5.744-3.192 9.042a80.988 80.988 0 0 1-2.447 5.32c-8.723 3.404-14.042 7.233-14.787 10.85-.32 1.703.213 3.192 1.702 4.362.851.638 1.809 1.064 2.873 1.064.425 0 .85-.106 1.276-.213 4.043-1.064 8.404-7.021 11.596-13.085a60.408 60.408 0 0 1 6.596-2.127c2.872-.852 5.425-1.49 7.66-1.915 4.148 3.297 7.659 5.106 10.744 5.106 2.34.106 4.042-.745 5.638-2.34 2.34-2.34 1.383-4.362 1.064-4.894-1.915-2.979-7.766-3.617-16.49-2.021zm-27.873 17.554c-.425.106-.638 0-.85-.107-.426-.319-.426-.531-.32-.744.213-1.277 2.66-3.617 7.979-6.17-2.553 3.83-5.107 6.595-6.809 7.021zm15.107-41.809c.106-.212.212-.532 1.063-.532.745 0 1.064.32 1.277.532.958 1.383.851 4.894-.319 9.575-1.809-4.043-2.766-7.873-2.021-9.575zm2.978 26.596c-1.063.32-2.127.638-3.191.957.32-.744.638-1.489.957-2.127.745-2.021 1.596-4.043 2.34-6.17.852 1.17 1.597 2.234 2.341 2.978.958 1.064 1.915 2.022 2.873 2.98-1.703.425-3.511.85-5.32 1.382zm22.447 1.915c-.745.851-1.702 1.17-2.872 1.17-1.596 0-3.51-.745-5.745-2.234 6.17-.85 9.681-.213 8.617 1.064z",
  fill: "#ABABAB"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "7yuizacxoa",
  x: 3,
  y: 4,
  width: 141,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_390_534"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_390_534",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompliancePdfFileLargeExpired);
export default ForwardRef;